import { Component, OnInit } from '@angular/core';
import { MatTableDataSource, MatDialog } from '@angular/material';
import { AngularFireDatabase } from 'angularfire2/database';
import { DeclaracaoDetailsComponent } from './declaracao-details/declaracao-details.component';

@Component({
  selector: 'app-declaracao-view',
  templateUrl: './declaracao-view.component.html',
  styleUrls: ['./declaracao-view.component.scss']
})
export class DeclaracaoViewComponent implements OnInit {
  displayedColumns = ['data', 'name', 'see'];
  dataSource: any;
  declaracoes: any[] = [];
  constructor(private db: AngularFireDatabase, public dialog: MatDialog) { }

  ngOnInit() {
    this.load();
  }

load() {
  this.declaracoes = [];
  this.db.database.ref(`peddingDeclarations/imobiliaria`).once('value').then(res => {
    res.forEach(c => {
      const d = c.val();
      d.id = c.key;
      d.data = this.formatDate(d.created);
      this.declaracoes.push(d);
    });

    this.declaracoes.sort((a, b) => a.created < b.created ? -1 : 1);
    this.dataSource = new MatTableDataSource(this.declaracoes);
  });
}

applyFilter(filterValue: string) {
  filterValue = filterValue.trim(); // Remove whitespace
  filterValue = filterValue.toLowerCase(); // MatTableDataSource defaults to lowercase matches
  this.dataSource.filter = filterValue;
}
two(x) {
  if (x.toString().length === 1) {
    return '0' + x;
  }
  return x;
}

formatDate(x) {
  const d = new Date(x);
  return this.two(d.getDate()) + '/' + this.two((d.getMonth() + 1)) + '/' + d.getFullYear() + ' - ' +
  this.two(d.getHours()) + ':' + this.two(d.getMinutes()) + ':' + this.two(d.getSeconds());
}



open(id) {
  const dialogRef = this.dialog.open(DeclaracaoDetailsComponent, {
    width: '800px',
    // height: '75%',
    maxHeight: '80vh',
    data: {id}
  });
  dialogRef.afterClosed().subscribe(res => {
    if (res) {
      console.log(res);
    }

    this.load();
  });
}



}
